import React from "react";
import Modal from "components/DesignSystem/Modal/Modal";
import { FormikForm } from "components/FormikForm/FormikForm";
import { Button } from "components/DesignSystem/Button/Button";
import { TextArea } from "components/DesignSystem/TextArea/TextArea";
import * as Yup from "yup";
import { useSubmitFilingDraftCardMutation } from "store/apis/filingDraftReview";
import { FormikValues } from "formik";
import { ModalProps } from "types/utils/modal";
import { useToast } from "hooks/useToast";
import { BackendError } from "types/utils/error";

const rejectFilingValidationSchema = Yup.object().shape({
  reason: Yup.string().required("Please provide a reason for rejection"),
});

export const RejectFilingDraft = ({
  isOpen,
  close,
  groupId,
  draftId,
  closeParent,
}: ModalProps & {
  groupId: string;
  draftId: string;
  closeParent: () => void;
}) => {
  const [rejectFilingDraft, { isLoading }] = useSubmitFilingDraftCardMutation({
    fixedCacheKey: `submitDftFilingDraft_${draftId}`,
  });
  const { alertToast, successToast } = useToast();

  const onSubmit = async (values: FormikValues) => {
    try {
      await rejectFilingDraft({
        groupId,
        draftId,
        isApproved: false,
        rejectionReason: values.reason,
      }).unwrap();
      close();
      closeParent();
      successToast({
        message: "Filing Draft rejected successfully.",
      });
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content>
        <FormikForm
          initialValues={{ reason: "" }}
          validationSchema={rejectFilingValidationSchema}
          onSubmit={onSubmit}
          noValidate
        >
          <>
            <Modal.Header>
              <Modal.Title>Reject Draft</Modal.Title>
              <Modal.Close />
            </Modal.Header>
            <Modal.Body>
              <TextArea
                name="reason"
                label="Reason for Rejection"
                placeholder="Briefly describe what’s incorrect "
                required
                rows={5}
                autoResize
              />
            </Modal.Body>
            <Modal.FooterButtonGroup>
              <Modal.RawClose asChild>
                <Button>Go back</Button>
              </Modal.RawClose>
              <Button type="submit" isLoading={isLoading} customType="primary">
                Save & Reject
              </Button>
            </Modal.FooterButtonGroup>
          </>
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
